import http from "./http-common";
import pubhttp from "./http-public";
import { env } from "process";

class Service {

  getIndustryCatById(requestJson) {
    // alert("9"+process.env.REACT_APP_AWS_API);
    return fetch(process.env.REACT_APP_AWS_API + "getIndustryCatById", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        alert(error);
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  fileUploadS3URL(requestJson) {
    // alert("9"+process.env.REACT_APP_AWS_API);
    return fetch(process.env.REACT_APP_AWS_API + "fileUploadS3URL", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        alert(error);
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  getEducationsById(eduid) {
    return pubhttp.get(`/getEducationsById?id=` + eduid);
  }

  getJobLocationsById(locid) {
    return pubhttp.get(`/getJobLocationsById?id=` + locid);
  }

  getJobTypesById(jobtypeid) {
    return pubhttp.get(`/getJobTypesById?id=` + jobtypeid);
  }

  getCompanyVideosByCompanyId(companyId) {

    return pubhttp.get(`/getCompanyVideosByCompanyId?companyId=` + companyId);

  }

  getCompanyJobExpiredCurrent(companyId, status, title, pageSize, pageNumber, sortBy, sortDir, siteId) {
    return pubhttp.get(`/getCompanyJobExpiredCurrent?siteId=` + siteId + `&companyId=` + companyId + `&status=` + status + `&title=` + title + `&pageSize=` + pageSize + `&pageNumber=` + pageNumber + `&sortBy=` + sortBy + `&sortDir=` + sortDir);
  }

  getStatesFromWage() {
    return pubhttp.get(`https://wagesurvey.hometownopportunity.com/api/statesList`);
  }

  getSurveyWageList(requestJson) {
    return fetch("https://wagesurvey.hometownopportunity.com/api/getSurveyWageList", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }


  updateCompanyVideo(requestJson) {
    return fetch(process.env.REACT_APP_AWS_API + "updateCompanyVideo", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  updateCompanyFeaturedVideo(requestJson) {
    return fetch(process.env.REACT_APP_AWS_API + "updateFeaturedVideoInCompanyVideos", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }


  getCountyByStateFromWage(requestJson) {
    return fetch("https://wagesurvey.hometownopportunity.com/api/getCountyList", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminGetCompanyList(siteId, pageSize, pageNumber, searchTxt, statuschk, sortBy, sortDir) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return pubhttp.get(`/adminGetCompanyList?siteId=` + siteId + `&status=` + statuschk + `&pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&sortBy=` + sortBy + `&sortDir=` + sortDir + `&title=&searchTxt=` + searchTxt);
  }

  adminGetCompanyProfile(companyId) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return pubhttp.get(`/adminGetCompanyProfile?companyId=` + companyId);
  }
  getIndustryData() {
    //return pubhttp.get(`/getIndustryData`);    
    return pubhttp.get(`/getIndustryData?name&pageSize=2000&pageNumber=1`);
  }

  getDashBoardUserCount() {
    return pubhttp.get(`/getUsersCount`);
  }

  adminGetEventTypesList() {
    //return pubhttp.get(`/getIndustryData`);    
    return pubhttp.get(`/getEventTypes`);
  }

  getIndustryDataPag(searchTxt, pageSize, pageNumber) {
    //return pubhttp.get(`/getIndustryData`);    
    return pubhttp.get(`/getIndustryData?pageSize=` + pageSize + `&pageNumber=` + pageNumber + `&name=` + searchTxt);
  }
  getLocationCounty() {

    // return pubhttp.get(`/getJobLocationCounty`);
    return pubhttp.get(`/getJobLocationCounty?name&pageSize=2000&pageNumber=1&siteId=2`);

  }

  listJobLocationCountyPag(searchTxt, pageSize, pageNumber, siteIdIn) {

    // return pubhttp.get(`/getJobLocationCounty`);
    return pubhttp.get(`/getJobLocationCounty?name=` + searchTxt + `&pageSize=` + pageSize + `&pageNumber=` + pageNumber + `&siteId=` + siteIdIn);

  }


  getSchoolnData() {

    return pubhttp.get(`/getSchoolnData`);

  }
  getJobType() {

    //return pubhttp.get(`/getJobType`);
    return pubhttp.get(`/getJobType?name&pageSize=2000&pageNumber=1`);

  }
  getJobTypePag(searchTxt, pageSize, pageNumber) {

    //return pubhttp.get(`/getJobType`);
    return pubhttp.get(`/getJobType?name=` + searchTxt + `&pageSize=` + pageSize + `&pageNumber=` + pageNumber);

  }
  getEducation() {

    // return pubhttp.get(`/getEducationData`);
    return pubhttp.get(`/getEducationData?name&pageSize=2000&pageNumber=1`);

  }
  getEducationListPag(searchTxt, pageSize, pageNumber) {

    // return pubhttp.get(`/getEducationData`);
    return pubhttp.get(`/getEducationData?name=` + searchTxt + `&pageSize=` + pageSize + `&pageNumber=` + pageNumber);

  }
  /*
    getEventsbySiteId(siteId){
      //alert("10"+siteId);
      const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
      return pubhttp.get(EndPoint+`listEvent?siteId=`+siteId);
    }
  */
  getSearchCompanyByName(name) {
    return pubhttp.get(`/searchCompanyByName?name=` + name);
  }

  getNotificationListbySiteId(siteId, pageSize, pageNumber, searchTxt) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return pubhttp.get(EndPoint + `adminNotificationList?siteId=` + siteId + `&pageSize=` + pageSize + `&pageNumber=` + pageNumber + `&searchTxt=` + searchTxt);
  }
  getEventsbySiteId(siteId, pageSize, pageNumber, searchTxt) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return pubhttp.get(EndPoint + `listEvent?siteId=` + siteId + `&pageSize=` + pageSize + `&pageNumber=` + pageNumber + `&searchTxt=` + searchTxt);
  }


  getCompanybyAlpha(alphaval) {
    //alert("10"+siteId);
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return pubhttp.get(EndPoint + `adminSearchCompanyByAlphabet?alphabet=` + alphaval);
  }


  getAdminJobList(siteId, titleKeyWord, status, pageNumber, pageSize, sortBy, sortDir, searchTxt) {
    //alert("10"+siteId);
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return pubhttp.get(EndPoint + `adminGetCompanyJobExpiredCurrent?title=` + titleKeyWord + `&status=` + status + `&pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&sortBy=` + sortBy + `&sortDir=` + sortDir + `&siteId=` + siteId + `&searchTxt=` + searchTxt);
  }


  getNotificationById(notificationId) {
    //alert("10"+eventId);
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return pubhttp.get(EndPoint + `adminViewNotification?notificationId=` + notificationId);

  }

  getEventById(eventId) {
    //alert("10"+eventId);
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return pubhttp.get(EndPoint + `adminViewEvent?eventId=` + eventId);
  }

  adminViewJobProfile(jobId) {
    //alert("10"+eventId);
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return pubhttp.get(EndPoint + `adminViewJobProfile?jobId=` + jobId);
  }


  adminAddIndustryCategory(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminAddIndustryCategory", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  getJobReportList(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "getAdminCompanyJobList", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  getJobReportListTime(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    /*const response = async fetch(EndPoint+"getAdminCompanyJobList", requestJson);
    const data = response.json();
    return data; */
    return fetch(EndPoint + "getAdminCompanyJobList", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  getStudentReportList(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminFilterStudent", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  getProfileReportList(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminFilterProfile", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  getCompanyReportList(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "getAdminCompanyReports", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  //http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/adminViewJobapplication
  admincallViewJobapplication(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminViewJobapplication", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminEditIndustryCategory(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminEditIndustryCategory", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  admineditCompanyLogo(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "postLogo", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  admineditCompanyBanner(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "postBanner", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  admineditCompanyVideo(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "editCompanyVideo", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  createSchoolAdmin(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "createSchoolAdmin", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }


  createSchoolSuperAdmin(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "createSchoolSuperAdmin", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }


  adminCreateJobLocationCounty(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminCreateJobLocationCounty", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }
  udpateadminJobLocationCounty(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "udpateadminJobLocationCounty", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminEditNotification(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminEditNotification", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminCreateNotification(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminCreateNotification", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminaddEvent(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "createEvent", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminMergeCompanies(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminMergeCompanies ", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  admineditEvent(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "udpateEvent", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminCreateJobtype(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminAddJobType", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }


  inactivateCompany(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "inactivateCompany", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  switchUserFromCompanytoAnother(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "switchUserFromCompanytoAnother", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminEditJobType(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminEditJobType", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminAddEducation(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminAddEducation", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminEditEducation(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminEditEducation", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminViewSchool(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminViewSchool", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminDeleteSchool(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "deleteSchool", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminEditProfile(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "editAdminProfile", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  listJobLocationCounty(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "listJobLocationCounty", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  jobsList(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "getCompanyJobList", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }


  adminGetstudentList(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminGetstudentList", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }


  getSchoolnDatapag(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "getSchoolnData", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminAddSchool(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminAddSchool", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminEditSchool(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminEditSchool", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }



  adminRegisterCompany(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminRegisterCompany", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }



  adminEditCompanyUser(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminEditCompanyUser", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminAddCompanyUser(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminAddCompanyUser", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminEditJob(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminEditJob", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminCreateStudent(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "studentRegistration", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminCreateJob(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminAddCompanyJob", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminAddProfile(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "postProfile", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  getCompnayListForMerg(furl) {
    return pubhttp.get(furl);
  }

  getStudentProfile(studentId) {
    return http.get(`/getStudentDataById?studentId=` + studentId);
  }

  adminGetStudentDataById(studentId) {
    return pubhttp.get(`/adminGetStudentDataById?studentId=` + studentId);
  }

  getPerkCategoryList() {
    return pubhttp.get(`/getPerksCategoryIdTitle`);
  }

  getPerksByCategoryId(perkCatId) {
    return pubhttp.get(`/getPerksByCategoryId?perksCategoryId=` + perkCatId);
  }

  addPerksToCompany(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "addPerksToCompany", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  deletePerkFromCompany(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "deletePerkFromCompany", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }


  applicationlistbycompany(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "applicationlistbycompany", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  adminGetUserInfo(userId) {
    return pubhttp.get(`/adminGetUserInfo?userId=` + userId);
    //return http.get(`/adminGetUserInfo?userId=`+userId);
  }

  adminGetProfile(profileId) {
    return pubhttp.get(`/getProfile?profileId=` + profileId);
  }

  getSchoolList(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API
    return fetch(EndPoint + "getSchoolnData", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }
  getEnrolledCollege() {

    return pubhttp.get(`/getEnrolledCollege`);

  }

  adminEditStudentProfile(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "editStudentProfile", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });

  }

  adminEditCompanyProfile(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminEditCompanyProfile", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });

  }

  studentRegistration(requestJson) {
    return fetch(process.env.React_App_AWS_API + "studentRegistration", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });
  }

  getAdminProfileList(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "getAdminProfileList", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });


  }


  adminVerify(requestJson) {
    const EndPoint = process.env.REACT_APP_AWS_API;
    fetch(EndPoint+"adminVerify",requestJson).then((response) => {
      // for each response header, log an array with header name as key
      //return(response.headers)
      var rt =  response.status;
      if(rt == "401"){
        window.location.reload();
      }
      //console.log(...response.headers);
      
    });

  }

  applicationlistbycompanyChk (requestJson){
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    /*
    return fetch(EndPoint+"applicationlistbycompany",requestJson)
    .then(response => { return response.status();})
    .then(responseData => {return responseData;})
    .catch(error => {
      console.error(error);
      return { name: "network error", description: "" };
    }); 
    */

     fetch(EndPoint+"applicationlistbycompany",requestJson).then((response) => {
      // for each response header, log an array with header name as key
      //return(response.headers)
      var rt =  response.status;
      if(rt == "401"){
        window.location.reload();
      }
      //console.log(...response.headers);
      
    });

    /*
    fetch(EndPoint+"applicationlistbycompany",requestJson).then((response) => {
      console.log("response from service-->"+response.status); // returns 200
      return response.status;
      console.log(response.status); // returns 200
     
    });
    */


  }

  getAdminProfileListExpired(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "getAdminProfileListExpired", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error("--->"+error);
        return { name: "network error", description: "" };
      });


  }

  getAdminProfileListActive(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "getAdminProfileListActive", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });


  }

  getAdminUserList(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminUserList", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });


  }

  adminJobApplication(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "adminJobApplication", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error(error);
        return { name: "network error", description: "" };
      });


  }

  getAdminUpdateFeaturedVideos(requestJson) {
    //const EndPoint = "http://career-sites-elb-301007931.us-east-2.elb.amazonaws.com/";
    const EndPoint = process.env.REACT_APP_AWS_API;
    return fetch(EndPoint + "updateFeaturedVideos", requestJson)
      .then(response => { return response.json(); })
      .then(responseData => { return responseData; })
      .catch(error => {
        console.error("--->"+error);
        return { name: "network error", description: "" };
      });
  }

  getAdminCompanyFeaturedVideos() {
    return pubhttp.get(`/getCompanyFeaturedVideos`);
  }


}

export default new Service();